import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { api } from "../lib/api";

export function Blog() {
    const [posts, setPosts] = useState([]);
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        api.get("/blog").then(r => setPosts(r.data)).finally(() => setLoading(false));
    }, []);
    return (
        <div className="px-6 md:px-12 lg:px-24 py-16" data-testid="blog-page">
            <div className="overline mb-3">Diario</div>
            <h1 className="font-display text-5xl tracking-tight text-[color:var(--ms-charcoal)] mb-3">Il Blog</h1>
            <p className="text-[color:var(--ms-muted)] text-base mb-10 max-w-xl">Guide di stile, consigli per genitori, ispirazioni per ogni stagione.</p>
            {loading ? <div className="text-[color:var(--ms-muted)] text-sm">Caricamento…</div> : posts.length === 0 ? (
                <div className="panel p-16 text-center text-[color:var(--ms-muted)]" data-testid="blog-empty">
                    Presto nuovi articoli. Iscriviti alla newsletter per non perderli.
                </div>
            ) : (
                <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-x-6 gap-y-12">
                    {posts.map(p => (
                        <Link to={`/blog/${p.slug}`} key={p.id} className="group" data-testid={`blog-card-${p.id}`}>
                            <div className="aspect-[4/3] bg-[color:var(--ms-cream)] overflow-hidden">
                                {p.cover_image && <img src={p.cover_image} alt={p.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />}
                            </div>
                            <div className="overline mt-4">{new Date(p.created_at).toLocaleDateString("it-IT")}</div>
                            <h2 className="font-display text-2xl text-[color:var(--ms-charcoal)] mt-1 group-hover:text-[color:var(--ms-sage-dark)] transition-colors">{p.title}</h2>
                            <p className="text-[color:var(--ms-muted)] text-sm mt-2 line-clamp-2">{p.excerpt}</p>
                        </Link>
                    ))}
                </div>
            )}
        </div>
    );
}

export function BlogPost() {
    const { slug } = useParams();
    const [post, setPost] = useState(null);
    useEffect(() => {
        api.get(`/blog/${slug}`).then(r => setPost(r.data)).catch(() => setPost(false));
    }, [slug]);
    if (post === false) return <div className="px-6 py-20 text-center text-[color:var(--ms-charcoal)]">Articolo non trovato</div>;
    if (!post) return <div className="px-6 py-20 text-[color:var(--ms-muted)]">Caricamento…</div>;
    return (
        <article className="px-6 md:px-24 lg:px-48 py-16 max-w-4xl mx-auto" data-testid="blog-post">
            <Link to="/blog" className="overline link-underline">← TORNA AL BLOG</Link>
            {post.cover_image && (
                <div className="aspect-video bg-[color:var(--ms-cream)] mt-8 overflow-hidden">
                    <img src={post.cover_image} alt={post.title} className="w-full h-full object-cover" />
                </div>
            )}
            <div className="overline mt-8">{new Date(post.created_at).toLocaleDateString("it-IT")} · {post.author}</div>
            <h1 className="font-display text-5xl tracking-tight text-[color:var(--ms-charcoal)] mt-3">{post.title}</h1>
            <p className="text-[color:var(--ms-sage-dark)] text-lg mt-3 font-light">{post.excerpt}</p>
            <div className="mt-10 text-[color:var(--ms-charcoal)] text-base leading-relaxed whitespace-pre-wrap" data-testid="blog-content">{post.content}</div>
        </article>
    );
}
